import {inject,Pipe,PipeTransform} from '@angular/core';
import {PhoneNumberFormat} from 'google-libphonenumber';
import {PHONE_NUMBER_UTIL} from '../../../common/phone-number/phone-number.tokens';

type PhoneFormatName='international'|'national'|'e164'|'rfc3966';

const FORMATS:Record<PhoneFormatName,PhoneNumberFormat>={
	international:PhoneNumberFormat.INTERNATIONAL,
	national:PhoneNumberFormat.NATIONAL,
	e164:PhoneNumberFormat.E164,
	rfc3966:PhoneNumberFormat.RFC3966
};

@Pipe({name:'phoneFormat'})
export class PhoneFormatPipe implements PipeTransform{
	private readonly phoneNumberUtil=inject(PHONE_NUMBER_UTIL);

	transform(phone:string|null|undefined,format:PhoneFormatName='international'):string{
		if(!phone){
			return '';
		}
		try{
			return this.phoneNumberUtil.format(this.phoneNumberUtil.parse(phone),FORMATS[format]);
		}catch{
			return phone;
		}
	}
}
